import React from "react";
import classNames from "classnames/bind";

import { Product, ProductType } from "@core/types";
import { useCreatePriceMarkup } from "../../../../../utils/useCreatePriceMarkup";
import styles from "./MainPageProduct.module.scss";

import { useConfig } from "../../../../../providers/config";
import { useCartData } from "../../../../../providers/cartDataStore";
import { useTranslation } from "react-i18next";

interface ProductPriceProps {
  product: Product;
}

const cx = classNames.bind(styles);

export const ProductPrice = ({ product }: ProductPriceProps) => {
  const { t } = useTranslation();
  const priceHtml = useCreatePriceMarkup(product);
  const { cartProductsMap } = useCartData();
  const { minLowStockThresholdToShowNumber, showStockQuantity } = useConfig();

  const priceClassName = cx("price ellipsis", styles.price, styles.price__general, "!mb-0");

  if (
    cartProductsMap[product.id]?.quantity > 0 ||
    (product.stockQuantity === 0 && product.type !== ProductType.VARIABLE)
  ) {
    return null;
  }

  const isProductStockLow =
    showStockQuantity &&
    minLowStockThresholdToShowNumber &&
    product &&
    product.stockQuantity &&
    product.stockQuantity <= minLowStockThresholdToShowNumber;

  return (
    <>
      {isProductStockLow ? (
        <div className="flex flex-col">
          <div className="text-[.65rem]">
            {t("Remain")} {product.stockQuantity} {product.portionUnit}
          </div>
          <p className={priceClassName} dangerouslySetInnerHTML={priceHtml}></p>
        </div>
      ) : (
        <p className={priceClassName} dangerouslySetInnerHTML={priceHtml}></p>
      )}
    </>
  );
};
